import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IApplication, ICompany, IInterview, IJobOffer } from '../../../../../assets/types/dtoTypes';

@Injectable( {
  providedIn: 'root',
} )
export class CompanyDashboardPageService {
  private http = inject(HttpClient);


  private comapnyUrl = `${environment.apiUrl}/companies`;

  private jobsUrl = `${environment.apiUrl}/job-offers/partner`;

  private applicationsUrl = `${environment.apiUrl}/job-applications`;

  private interviewsUrl = `${environment.apiUrl}/interviews`;

  constructor() {}

  public getCompanyData( id: string ): Observable<ICompany> {
    const url = `${this.comapnyUrl}/${id}`;
    return this.http.get<ICompany>( url );
  }

  public getJobOffers(): Observable<IJobOffer[]> {
    return this.http.get<IJobOffer[]>( this.jobsUrl );
  }

  public getApplications( id: string ): Observable<IApplication[]> {
    const url = `${this.applicationsUrl}/${id}/applications`;
    return this.http.get<IApplication[]>( url );
  }

  public getInterviewsByApplication( applicationId: string ): Observable<IInterview[]> {
    return this.http.get<IInterview[]>( `${this.interviewsUrl}/job-application/${applicationId}` );
  }

}
